<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Device Deployment Utility">
     Device Deployment Utility
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history-chapter.html#change-history-chapter" title="Change history">
     Change history
    </a>
   </p>
   <div id="divd0e10">
   </div>
   <p class="toc-1-style">
    <a href="overview-package-installer.html#overview-package-installer" title="Overview">
     Overview
    </a>
   </p>
   <div id="divd0e180">
    <p class="toc-2-style">
     <a href="overview-package-installer.html#ddu-system-requirements" title="System requirements">
      System requirements
     </a>
    </p>
    <p class="toc-2-style">
     <a href="overview-package-installer.html#supported-languages" title="Supported languages">
      Supported languages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="overview-package-installer.html#ddu-supported-printers" title="Supported printer models">
      Supported printer models
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-the-utility-chapter.html#using-the-utility-chapter" title="Using the utility">
     Using the utility
    </a>
   </p>
   <div id="divd0e778">
    <p class="toc-2-style">
     <a href="launching-user-interface-topic.html#launching-user-interface" title="Launching DDU">
      Launching DDU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-user-interface-group.html#d0e827" title="Using the graphical user interface">
      Using the graphical user interface
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-command-line-group.html#d0e2564" title="Using the command line">
      Using the command line
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="configuring-the-utility-chapter.html#configuring-the-utility-chapter" title="Configuring the utility">
     Configuring the utility
    </a>
   </p>
   <div id="divd0e5598">
    <p class="toc-2-style">
     <a href="configuring-default-csv-discovery-settings-topic.html#configuring-default-csv-discovery-settings" title="Configuring deployment and discovery settings using the app-config file">
      Configuring deployment and discovery settings using the app-config file
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-deployment-settings-topic.html#configuring-deployment-settings" title="Configuring deployment and discovery settings using DDU">
      Configuring deployment and discovery settings using DDU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-deployment-settings-topic.html#understanding-deployment-settings" title="Understanding advanced settings">
      Understanding advanced settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-logging-settings-topic.html#configuring-logging-settings" title="Configuring log settings">
      Configuring log settings
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubelshooting-package-installer.html#troubelshooting-package-installer" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e6154">
    <p class="toc-2-style">
     <a href="firewall-prompt-appears-when-launching-DDU-topic.html#firewall-prompt-appears-when-launching-DDU" title="A firewall prompt appears when launching DDU">
      A firewall prompt appears when launching DDU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-launch-utility-topic.html#trb-cannot-launch-utility" title="Cannot launch DDU">
      Cannot launch DDU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-deploy-solutions-topic.html#trb-cannot-deploy-solutions" title="Cannot deploy solutions">
      Cannot deploy solutions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-deploy-to-MPS-elite-device-topic.html#trb-cannot-deploy-to-MPS-elite-device" title="Cannot deploy to a device with MPS Elite settings">
      Cannot deploy to a device with MPS Elite settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-discover-devices-topic.html#cannot-discover-devices" title="Cannot discover devices">
      Cannot discover devices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-discover-devices-snmpv3-topic.html#cannot-discover-snmpv3-devices" title="Cannot discover devices using SNMPv3">
      Cannot discover devices using SNMPv3
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-deploy-license-topic.html#cannot-deploy-license" title="Cannot deploy license for eSF application packages">
      Cannot deploy license for eSF application packages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-see-applicaiton-in-application-list-topic.html#trb-cannot-see-applicaiton-in-application-list" title="Cannot see the application in the DDU application list">
      Cannot see the application in the DDU application list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="incorrect-esf-deployed-topic.html#incorrect-esf-deployed" title="Incorrect eSF application is deployed">
      Incorrect eSF application is deployed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="utility-stops-topic.html#utility-stops" title="DDU stops when launching from a CD or DVD">
      DDU stops when launching from a CD or DVD
     </a>
    </p>
    <p class="toc-2-style">
     <a href="eSF-application-settings-not-updated-topic.html#eSF-application-settings-not-updated" title="Settings for eSF applications are not updated after deployment">
      Settings for eSF applications are not updated after deployment
     </a>
    </p>
    <p class="toc-2-style">
     <a href="advanced-settings-not-working-topic.html#advanced-settings-not-working" title="Some advanced settings for the workflow are not working">
      Some advanced settings for the workflow are not working
     </a>
    </p>
    <p class="toc-2-style">
     <a href="export-device-data-operation-fails-topic.html#export-device-data-operation-fails" title="Export Device Data operation fails">
      Export Device Data operation fails
     </a>
    </p>
    <p class="toc-2-style">
     <a href="timeout-error-during-downloading-exporting-device-data-topic.html#timeout-error-during-downloading-exporting-device-data" title="Timeout error during downloading or exporting of device data">
      Timeout error during downloading or exporting of device data
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-deploy-more-than-one-pkcs-task-in-quick-succession-topic.html#cannot-deploy-more-than-one-pkcs-task-in-quick-succession" title="Cannot deploy more than one PKCS task in quick succession">
      Cannot deploy more than one PKCS task in quick succession
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e6557">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e6560" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e6597" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue